import { leadConstants } from "../constants";
import { history } from "../helpers";
import { leadService } from "../services";
import { alertActions } from "./alertActions";

export const leadActions = {
  addLead,
  getLeads,
  getLeadsPaginated,
  uploadExcel,
  addNote,
  clearAddNote,
  changeToSaleOpportunity,
  pinLead,
  editContactInformation,
  getCancellationReason,
  cancelLead,
  acceptLead,
};

function addLead(lead) {
  return (dispatch) => {
    dispatch(request(leadConstants.ADD_LEAD_REQUEST));
    leadService.addLead(lead).then(
      (res) => {
        console.log(res);

        if (res === undefined) {
          dispatch(
            alertActions.error("ارتباط با سرور برقرار نیست.سرنخ شما ثبت نشد")
          );
          dispatch(
            failure(
              leadConstants.ADD_LEAD_FAILURE,
              "ارتباط با سرور برقرار نیست.سرنخ شما ثبت نشد"
            )
          );
        } else if (res.data.status) {
          // console.log("lead added");
          dispatch(success(leadConstants.ADD_LEAD_SUCCESS, lead));
          dispatch(alertActions.success(res.message));
        } else if (res.data.status === false) {
          dispatch(failure(leadConstants.ADD_LEAD_FAILURE, lead));
          dispatch(alertActions.error(res.message));
        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 800);
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(
          alertActions.error(leadConstants.ADD_LEAD_FAILURE, error.toString())
        );
      }
    );
  };
}

function getLeads(params) {
  return (dispatch) => {
    dispatch(request(leadConstants.GET_LEADS_REQUEST));
    leadService.getLeads(params).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست."));
          dispatch(
            failure(
              leadConstants.GET_LEADS_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
          setTimeout(() => {
            dispatch(alertActions.clear());
          }, 800);
        } else if (res.success) {
          dispatch(success(leadConstants.GET_LEADS_SUCCESS, res));
        } else if (res.success === false) {
          dispatch(failure(leadConstants.GET_LEADS_FAILURE));
          dispatch(alertActions.error(res.message));
          setTimeout(() => {
            dispatch(alertActions.clear());
          }, 800);
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(
          alertActions.error(leadConstants.GET_LEADS_FAILURE, error.toString())
        );
      }
    );
  };
}

function getLeadsPaginated(params = {}) {
  return (dispatch) => {
    dispatch(request(leadConstants.GET_LEADS_REQUEST));
    leadService.getLeadsPaginated(params).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست."));
          dispatch(
            failure(
              leadConstants.GET_LEADS_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.success) {
          dispatch(success(leadConstants.GET_LEADS_SUCCESS, res));
        } else if (res.success === false) {
          dispatch(failure(leadConstants.GET_LEADS_FAILURE, res.message));
          dispatch(alertActions.error(res.message));
        }

        setTimeout(() => dispatch(alertActions.clear()), 800);
      },
      (error) => {
        dispatch(failure(leadConstants.GET_LEADS_FAILURE, error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
}

function uploadExcel(param) {
  return (dispatch) => {
    dispatch(request(leadConstants.UPLOAD_EXCEL_REQUEST));
    leadService.uploadExcel(param).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(failure(leadConstants.UPLOAD_EXCEL_FAILURE));
        } else if (res.success) {
          console.log("Excel Products uploaded");
          dispatch(success(leadConstants.UPLOAD_EXCEL_SUCCESS, res.message));
          dispatch(alertActions.success(res.message));
        } else if (res.success === false) {
          dispatch(alertActions.error(res.message));
          dispatch(failure(leadConstants.UPLOAD_EXCEL_FAILURE, res.message));
        }
      },
      (error) => {
        dispatch(failure(leadConstants.UPLOAD_EXCEL_FAILURE, error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
}

function addNote(params) {
  return (dispatch) => {
    dispatch(request(leadConstants.ADD_NOTES_REQUEST));
    leadService.addNote(params).then(
      (res) => {
        console.log(res);
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              leadConstants.ADD_NOTES_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.data.status) {
          console.log("lead note added");
          dispatch(success(leadConstants.ADD_NOTES_SUCCESS, res));
          dispatch(alertActions.success(res.message));
        } else if (res.data.status === false) {
          dispatch(failure(leadConstants.ADD_NOTES_FAILURE, res.message));
          dispatch(alertActions.error(res.message));
        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1000);
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(
          alertActions.error(leadConstants.ADD_NOTES_FAILURE, error.toString())
        );
      }
    );
  };
}

function changeToSaleOpportunity(params, callBack) {
  return (dispatch) => {
    dispatch(request(leadConstants.CHANGE_TO_SALE_OPPORTUNITY_REQUEST));
    leadService.changeToSaleOpportunity(params).then(
      (res) => {
        console.log(res);
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              leadConstants.CHANGE_TO_SALE_OPPORTUNITY_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.data.status) {

          dispatch(alertActions.success(res.message));
          dispatch(success(leadConstants.CHANGE_TO_SALE_OPPORTUNITY_SUCCESS, res));
          dispatch(getLeadsPaginated({ sort: "0", phoneNumber: "0", filter: "0", page: 1, pageSize: 10 }));
          return callBack()

        } else if (res.data.status === false) {
          dispatch(
            failure(
              leadConstants.CHANGE_TO_SALE_OPPORTUNITY_FAILURE,
              res.message
            )
          );
          dispatch(alertActions.error(res.message));
        }

        setTimeout(() => { dispatch(alertActions.clear()); }, 1000);
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(
          alertActions.error(
            leadConstants.CHANGE_TO_SALE_OPPORTUNITY_FAILURE,
            error.toString()
          )
        );
      }
    );
  };
}



function pinLead(params) {
  return (dispatch) => {
    dispatch(request(leadConstants.PIN_LEAD_REQUEST));
    leadService.pinLead(params).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(failure(leadConstants.PIN_LEAD_FAILURE, "ارتباط با سرور برقرار نیست"));
        } else if (res.success) {
          dispatch(alertActions.success(res.message));
          dispatch(success(leadConstants.PIN_LEAD_SUCCESS, res));
          dispatch(getLeadsPaginated({ sort: "0", phoneNumber: "0", filter: "0", page: 1, pageSize: 10 }));
        } else if (res.success === false) {
          dispatch(failure(leadConstants.PIN_LEAD_FAILURE, res.message));
          dispatch(alertActions.error(res.message));
        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1000);
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(leadConstants.PIN_LEAD_FAILURE, error.toString()));
      }
    );
  };
}


function editContactInformation(params, callBack) {
  return (dispatch) => {
    dispatch(request(leadConstants.EDIT_CONTACT_INFORMATION_REQUEST));
    leadService.editContactInformation(params).then(
      (res) => {
        if (res === undefined) {

          dispatch(alertActions.error("ارتباط با سرور برقرار نیست.سرنخ شما ثبت نشد"));
          dispatch(failure(leadConstants.EDIT_CONTACT_INFORMATION_FAILURE, "ارتباط با سرور برقرار نیست.سرنخ شما ثبت نشد"));

        } else if (res.success) {

          dispatch(alertActions.success(res.message));
          dispatch(success(leadConstants.EDIT_CONTACT_INFORMATION_SUCCESS, res));
          dispatch(getLeadsPaginated({ sort: "0", phoneNumber: "0", filter: "0", page: 1, pageSize: 10 }));
          return callBack()

        } else if (res.success === false) {

          dispatch(alertActions.error(res.message));
          dispatch(failure(leadConstants.EDIT_CONTACT_INFORMATION_FAILURE, res));

        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1000);
      },
      (error) => {
        console.log("occure error");
        console.log(error.toString());
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(leadConstants.EDIT_CONTACT_INFORMATION_FAILURE, error.toString()));
      }
    );
  };
}

function getCancellationReason() {
  return (dispatch) => {
    dispatch(request(leadConstants.GET_CANCELLATION_REASON_REQUEST));
    leadService.getCancellationReason().then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست.سرنخ شما ثبت نشد"));
          dispatch(failure(leadConstants.GET_CANCELLATION_REASON_FAILURE, "ارتباط با سرور برقرار نیست.سرنخ شما ثبت نشد"));

        } else if (res.success) {

          dispatch(success(leadConstants.GET_CANCELLATION_REASON_SUCCESS, res.data));

        } else if (res.success === false) {

          dispatch(alertActions.error(res.message));
          dispatch(failure(leadConstants.GET_CANCELLATION_REASON_FAILURE, res));

        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1000);
      },
      (error) => {
        console.log("occure error");
        console.log(error.toString());
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(leadConstants.GET_CANCELLATION_REASON_FAILURE, error.toString()));
      }
    );
  };
}

function cancelLead(params, callBack) {
  return (dispatch) => {
    dispatch(request(leadConstants.CANCEL_LEAD_REQUEST));
    leadService.cancelLead(params).then(
      (res) => {
        if (res === undefined) {

          dispatch(alertActions.error("ارتباط با سرور برقرار نیست."));
          dispatch(failure(leadConstants.CANCEL_LEAD_FAILURE, "ارتباط با سرور برقرار نیست."));

        } else if (res.success) {

          dispatch(success(leadConstants.CANCEL_LEAD_SUCCESS, res));
          dispatch(getLeadsPaginated({ sort: "0", phoneNumber: "0", filter: "0", page: 1, pageSize: 10 }));
          return callBack()

        } else if (res.success === false) {

          dispatch(alertActions.error(res.message));
          dispatch(failure(leadConstants.CANCEL_LEAD_FAILURE, res));

        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1000);
      },
      (error) => {
        console.log("occure error");
        console.log(error.toString());
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(leadConstants.CANCEL_LEAD_FAILURE, error.toString()));
      }
    );
  };
}

function acceptLead(params, callBack) {
  return (dispatch) => {
    dispatch(request(leadConstants.ACCEPT_LEAD_REQUEST));
    leadService.acceptLead(params).then(
      (res) => {
        if (res === undefined) {

          dispatch(alertActions.error("ارتباط با سرور برقرار نیست."));
          dispatch(failure(leadConstants.ACCEPT_LEAD_FAILURE, "ارتباط با سرور برقرار نیست."));

        } else if (res.success) {

          dispatch(success(leadConstants.ACCEPT_LEAD_SUCCESS, res));
          dispatch(getLeadsPaginated({ sort: "0", phoneNumber: "0", filter: "0", page: 1, pageSize: 10 }));
          return callBack()

        } else if (res.success === false) {

          dispatch(alertActions.error(res.message));
          dispatch(failure(leadConstants.ACCEPT_LEAD_FAILURE, res));

        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1000);
      },
      (error) => {
        console.log("occure error");
        console.log(error.toString());
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(leadConstants.ACCEPT_LEAD_FAILURE, error.toString()));
      }
    );
  };
}

function clearAddNote(params) {
  return (dispatch) => {
    dispatch(clear(leadConstants.ADD_NOTES_CLEAR));
  };
}

function request(type) {
  return { type: type };
}

function success(type, data) {
  return { type: type, data };
}

function failure(type, error) {
  return { type: type, error };
}

function clear(type) {
  return { type: type };
}
